import { useLocation, Link } from "react-router-dom";
import { Home } from "lucide-react";

/**
 * Global "Home Page" button. Rendered inside ProtectedRoute so it appears on
 * every authenticated page for New & Registered users (non-admins). It always
 * takes them back to the New User Landing Page — their single home base.
 * Hidden for admins (they use the /dashboard-new sidebar) and on the landing itself.
 */
const HomeButton = ({ user }) => {
  const location = useLocation();
  if (user?.is_admin) return null;
  if (location.pathname.startsWith("/home")) return null;
  // On the Registered Advisor page the "Home Page" action lives in the header.
  if (location.pathname.startsWith("/registered-advisor")) return null;
  // On the IPO Navigator the "Home" action lives in the top nav.
  if (location.pathname.startsWith("/ipo-navigator")) return null;
  // On the IPO Role Select page the "Home" action lives in the top bar.
  if (location.pathname.startsWith("/ipo-role-select")) return null;
  // On the CA Firm Dashboard the "Home Page" action lives in the top bar.
  if (location.pathname.startsWith("/ca-firm-dashboard")) return null;
  // On the Oracle IPO.GPT page the "Home Page" action lives in the top bar.
  if (location.pathname.startsWith("/oracle")) return null;
  // On the Advisor Onboarding page the "Home Page" action lives in the top bar.
  if (location.pathname.startsWith("/advisor-onboarding")) return null;
  // On the Advisor Marketplace the "Home Page" action lives in the top bar.
  if (location.pathname.startsWith("/advisor-marketplace")) return null;
  // On a dedicated Advisor Profile page the "Home Page" action lives in the header.
  if (location.pathname.startsWith("/advisor/")) return null;
  // On the DRHP Workspace the "Home Page" action lives in the top bar.
  if (location.pathname.startsWith("/drhp-workspace")) return null;
  // On the IPO Cost Estimator the "Home Page" action lives in the top bar.
  if (location.pathname.startsWith("/ipo-cost-estimator")) return null;
  // On the Published Projects page the "Home Page" button is removed by request.
  if (location.pathname.startsWith("/published-projects")) return null;

  return (
    <Link
      to="/home"
      className="fixed top-[112px] right-[44px] z-40 group flex items-center gap-2.5 pl-3.5 pr-5 py-2.5 rounded-full bg-[#0C447C] border border-[#0C447C] shadow-md hover:shadow-lg hover:bg-[#0a3a6b] transition-all no-underline"
      data-testid="home-page-btn"
      title="Home Page"
    >
      <Home className="w-5 h-5 text-white" strokeWidth={2.2} />
      <span className="text-[14px] font-semibold text-white hidden sm:inline">
        Home Page
      </span>
    </Link>
  );
};

export default HomeButton;
